import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { oktaAuth } from '../utils/okta';
import { toast } from 'react-toastify';
import { API } from './api';

interface IComment {
  breakId: string;
  commentDate: string;
  commentBy: string;
  comment: string;
}

export interface ICommentType {
  breakId: string;
  comment: string;
}

interface ISaveComment {
  comment: ICommentType;
  nextReviewDate: string | null;
}

interface ErrorResponse {
  status: number;
  data: {
    message: string;
  };
}

export const EmptyComment: ICommentType = {
  breakId: '',
  comment: '',
};

export const commentApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: API.BaseURL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const tokens = oktaAuth.tokenManager.getTokensSync();

      if (!tokens.accessToken) return;

      headers.set('Content-Type', API.contentType);
      headers.set('Authorization', `${tokens.accessToken.tokenType} ${tokens.accessToken.accessToken}`);

      return headers;
    },
  }),
  reducerPath: 'apa',
  tagTypes: ['ReconCommentsData', 'ReconGridData'],
  endpoints: (build) => ({
    getReconComments: build.query({
      transformResponse: (baseQueryReturnValue?: IComment[]): IComment[] => baseQueryReturnValue!,
      transformErrorResponse: (response) => {
        toast.error(`Error loading comments. Error: ${response.status as string}`);
        return response;
      },
      query: (breakId: string) => `${API.endpoints.ReconCommentsData}?breakId=${breakId}`,
    }),
    createNewComment: build.mutation({
      transformResponse: (baseQueryReturnValue: string): string => baseQueryReturnValue,
      transformErrorResponse: (response: ErrorResponse) => {
        toast.error(`Add new Comment failed: ${response.data.message}`);

        return response;
      },
      query: ({ comment: initialComment, nextReviewDate = '' }: ISaveComment) => ({
        url: `${API.endpoints.SaveComment}?nextReviewDate=${nextReviewDate!}`,
        method: 'POST',
        body: initialComment,
      }),
      invalidatesTags: ['ReconGridData'],
    }),
  }),
});

export const { useGetReconCommentsQuery } = commentApiSlice;
